import {
    Box,
    Chip,
    IconButton,
    Tooltip,
    Typography,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import { SavedPaymentMethod } from "@/redux";

interface Props {
    card: SavedPaymentMethod;
    isSelected: boolean;
    onSelect: () => void;
    onDelete: () => void;
}

export default function SavedCardItem({
    card,
    isSelected,
    onSelect,
    onDelete,
}: Props) {
    return (
        <Box
            onClick={onSelect}
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.75,
                px: 2,
                py: 1.75,
                border: isSelected ? "2px solid" : "1px solid",
                borderColor: isSelected
                    ? "text.primary"
                    : "divider",
                borderRadius: 2,
                cursor: "pointer",
                bgcolor: "background.paper",
                transition: "border-color 0.15s",
                "&:hover": {
                    borderColor: "text.secondary",
                },
            }}
        >
            <Box
                sx={{
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    border: "1.5px solid",
                    borderColor: isSelected
                        ? "text.primary"
                        : "divider",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                }}
            >
                {isSelected && (
                    <Box
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            bgcolor: "text.primary",
                        }}
                    />
                )}
            </Box>

            <Box
                sx={{
                    width: 3,
                    height: 36,
                    borderRadius: 1,
                    flexShrink: 0,
                    bgcolor:
                        card.brand === "visa"
                            ? "#1A1F71"
                            : card.brand === "mastercard"
                                ? "#EB001B"
                                : card.brand === "amex"
                                    ? "#006FCF"
                                    : "#378ADD",
                }}
            />

            <Box sx={{ flex: 1 }}>
                <Typography
                    variant="h6"
                    sx={{
                        color: "text.secondary",
                        fontSize: {
                            xs: "1.1rem",
                            sm: "1.25rem",
                        },
                    }}
                >
                    {card.brand.toUpperCase()} •••• {card.last4}
                </Typography>

                <Chip
                    label={`Expires ${card.expMonth}/${card.expYear}`}
                    size="small"
                    sx={{
                        mt: 0.5,
                        borderRadius: "999px",
                        bgcolor: "#EAF3DE",
                        color: "#3B6D11",
                    }}
                />
            </Box>

            <Tooltip title="Delete card" arrow>
                <IconButton
                    size="small"
                    color="error"
                    onClick={(e) => {
                        e.stopPropagation();
                        onDelete();
                    }}
                >
                    <DeleteIcon />
                </IconButton>
            </Tooltip>
        </Box>
    );
}